export enum DrivingLicence_Enum {
  "Full UK" = 2,
  "International" = 4,
  "None" = 5,
  "Provisional UK" = 6,
  "EU" = 7,
}
